<template>
  <div>
    <component
    :is="componentName"
    v-model="linkModal"
    :index="index"
    @close="close"
    @add="add"
    @change="change"
    @closeModel="$emit('closeModel', $event)"
    ></component>
  </div>
</template>

<script>
import customLinkType0 from "@components/custom-component/common/custom-link/components/custom-link-type-1.vue";
export default {
  // 链接类型
  name: "custom-link",
  model: {
    prop: "linkModal",
    event: "sendLinkModal"
  },
  props: { 
    index: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: {
        title: "链接",
        icon: "icon-link",
        type: "link",
        componentName: "customLink",
        config: {
          type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
          name: "",
          url: ""
        }
      }
    },
    linkModal: {
      type: Array,
      default: function() {
        return [{
          type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
          name: "",
          url: "",
        }]
      }
    }
  },
  computed: {
    componentName() {
      // return `customLinkType${this.info.config.type}`;
      return `customLinkType0`;
    }
  },
  data() {
    return {};
  },
  components: {
    customLinkType0
  },
  methods: {
    close() {
      this.$emit('close');
    },
    add(item, idx) { 
      this.$emit('add', item, idx);
    },
    change(e) {
      this.$emit('sendLinkModal',e)
    }
  },
};
</script>

<style scoped lang="scss">
</style>
